import { render, staticRenderFns } from "./disabled.vue?vue&type=template&id=3fbe3678&scoped=true&"
import script from "./disabled.vue?vue&type=script&lang=js&"
export * from "./disabled.vue?vue&type=script&lang=js&"
import style0 from "./disabled.vue?vue&type=style&index=0&id=3fbe3678&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbe3678",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
